import React, { useState, useEffect } from 'react'
import Slider from "react-slick";

const BannerOne = () => {

    const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isMobile = windowWidth <= 768;
    const isTablet = windowWidth > 768 && windowWidth <= 1024;

    const getBannerHeight = () => {
        if (isMobile) return '250px';
        if (isTablet) return '380px';
        return '520px';
    };

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-next slick-arrow flex-center rounded-circle bg-white hover-bg-main-600 hover-text-white transition-1`}
                style={{
                    width: isMobile ? '30px' : '44px',
                    height: isMobile ? '30px' : '44px',
                    right: isMobile ? '8px' : '20px',
                    zIndex: 10,
                    opacity: isMobile ? 0.7 : 1,
                    display: isMobile ? 'flex' : 'flex'
                }}
            >
                <i className="ph ph-caret-right" style={{ fontSize: isMobile ? '14px' : '20px' }} />
            </button>
        );
    }

    function SamplePrevArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle bg-white hover-bg-main-600 hover-text-white transition-1`}
                style={{
                    width: isMobile ? '30px' : '44px',
                    height: isMobile ? '30px' : '44px',
                    left: isMobile ? '8px' : '20px',
                    zIndex: 10,
                    opacity: isMobile ? 0.7 : 1,
                    display: isMobile ? 'flex' : 'flex'
                }}
            >
                <i className="ph ph-caret-left" style={{ fontSize: isMobile ? '14px' : '20px' }} />
            </button>
        );
    }

    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 1500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        autoplay: true,
        autoplaySpeed: 5000,
    };

    const banners = [
        { id: 1, src: "assets/images/bg/hero-banner.png", alt: "Banner" },
        { id: 2, src: "assets/images/bg/hero-banner2.png", alt: "Banner" },
        { id: 3, src: "assets/images/bg/hero-banner1.png", alt: "Banner" }
    ];

    return (
        <div className="banner banner-one">
            <div className="container container-lg">
                <div
                    className="banner-item overflow-hidden position-relative"
                    style={{ 
                        padding: 0, 
                        borderRadius: isMobile ? '12px' : '24px',
                        background: '#f0f0f0',
                    }}
                >
                    <div className="banner-slider">
                        <Slider {...settings}>
                            {banners.map((banner) => (
                                <div key={banner.id} className="banner-slider__item" style={{ height: getBannerHeight() }}>
                                    <img
                                        src={banner.src}
                                        alt={banner.alt}
                                        style={{ 
                                            width: '100%', 
                                            height: '100%', 
                                            objectFit: 'cover',
                                            display: 'block'
                                        }}
                                    />
                                </div>
                            ))}
                        </Slider>
                    </div>

                    {/* Scroll Down Button - Only show on tablet/desktop */}
                    {!isMobile && (
                        <a
                            href="#featureSection"
                            className="scroll-down flex-center bg-main-600 rounded-circle border border-5 text-white border-white position-absolute start-50 translate-middle-x hover-bg-main-800"
                            style={{ 
                                zIndex: 2, 
                                bottom: '-12px',
                                width: '70px',
                                height: '70px',
                                textDecoration: 'none',
                                transform: 'translateX(-50%)'
                            }}
                        >
                            <span className="icon line-height-0">
                                <i className="ph ph-caret-double-down" style={{ fontSize: '22px' }} />
                            </span>
                        </a>
                    )}
                </div>
            </div>

            <style>{`
                .banner-one {
                    width: 100%;
                    overflow: hidden;
                }

                .banner-one .container {
                    padding-left: 15px;
                    padding-right: 15px;
                }

                .banner-slider {
                    width: 100%;
                    height: 100%;
                }

                .banner-slider .slick-slide {
                    height: auto;
                }

                .banner-slider .slick-slide > div {
                    height: 100%;
                }

                /* Slick dots styling - optional if you want dots */
                .slick-dots {
                    bottom: 12px;
                    z-index: 5;
                }

                .slick-dots li button:before {
                    font-size: 10px;
                    color: white;
                    opacity: 0.6;
                }

                .slick-dots li.slick-active button:before {
                    color: #10b981;
                    opacity: 1;
                }

                /* Scroll down button hover effect */
                .scroll-down {
                    transition: all 0.3s ease;
                    cursor: pointer;
                }

                .scroll-down:hover {
                    transform: translateX(-50%) translateY(-5px) !important;
                    background-color: #1a472a !important;
                }

                /* Mobile specific adjustments */
                @media (max-width: 768px) {
                    .banner-one .container {
                        padding-left: 12px;
                        padding-right: 12px;
                    }
                }

                @media (max-width: 576px) {
                    .banner-one .container {
                        padding-left: 10px;
                        padding-right: 10px;
                    }
                    
                    .slick-dots {
                        bottom: 8px;
                    }
                    
                    .slick-dots li button:before {
                        font-size: 8px;
                    }
                }
            `}</style>
        </div>
    );
}

export default BannerOne;